import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

@Injectable()
export class ImpostoService {

    getEmpresas(): Observable<HttpResponse<any>> {
        return this.http.get(
          environment.webApiSaguiControlUrl + '/api/impostoempresaproduto/visualizatodasempresas', { observe: 'response' })
    }

    getImpostos(): Observable<HttpResponse<any>> {
        return this.http.get(
          environment.webApiSaguiControlUrl + '/api/imposto/visualizatodas/', { observe: 'response' })
    }

    getImpostosPorTipoNota(tipoNotaFiscal: number): Observable<HttpResponse<any>> {
      return this.http.get(
        environment.webApiSaguiControlUrl + '/api/imposto/visualizaportiponota/?tipoNotaFiscal=' + tipoNotaFiscal, { observe: 'response' })
  }

    postVisualizaImpostosPorFiltro(item: any): Observable<HttpResponse<any>> {
        return this.http.post(
          environment.webApiSaguiControlUrl + '/api/impostoempresaproduto/visualizatodas/', item, { observe: 'response' })
    }

    getImpostoEmpresaProduto(itemId: any): Observable<HttpResponse<any>> {
        return this.http.get(
          environment.webApiSaguiControlUrl + '/api/impostoempresaproduto/visualiza/' + itemId, { observe: 'response' })
    }

    postImposto(item: any): Observable<HttpResponse<any>> {
        return this.http.post(
          environment.webApiSaguiControlUrl + '/api/impostoempresaproduto/inclui/', item, { observe: 'response' })
    };

    putImposto(item: any, itemId: any): Observable<HttpResponse<any>> {
        return this.http.put(
          environment.webApiSaguiControlUrl + '/api/impostoempresaproduto/atualiza/' + itemId, item, { observe: 'response' })
    };

    deleteImposto(itemId: any): Observable<HttpResponse<any>> {
        return this.http.delete(
          environment.webApiSaguiControlUrl + '/api/impostoempresaproduto/exclui/' + itemId, { observe: 'response' })
    }

    getListaServicos(): Observable<HttpResponse<any>> {
        return this.http.get(
          environment.webApiSaguiControlUrl + '/api/servicolista/visualizatodas', { observe: 'response' })
    }

    getListaServico(itemId: any): Observable<HttpResponse<any>> {
        return this.http.get(
          environment.webApiSaguiControlUrl + '/api/servicolista/visualizaporid/' + itemId, { observe: 'response' })
    }

    getFiltroImpostoEmpresaProduto(item: any): Observable<HttpResponse<any>> {
        return this.http.get(
          environment.webApiSaguiControlUrl + '/api/impostoempresaproduto/imposto/filtro-configurado/'+item, { observe: 'response' })
    }

        getAliquotasPorEmpresa(empresaId: number): Observable<HttpResponse<any>> {
        return this.http.get(
          environment.webApiSaguiControlUrl + '/api/AliquotaImposto/empresa/' + empresaId, { observe: 'response' })
    }

    excluirAliquota(aliquotaId: number): Observable<HttpResponse<any>> {
        return this.http.delete(
          environment.webApiSaguiControlUrl + '/api/AliquotaImposto/cancela/' + aliquotaId, { observe: 'response' })
    }

    constructor(private http: HttpClient, private sanitizer: DomSanitizer) {

    }
}
